const getters = {
  settings: (state) => state.settings,
};
export default getters;
